import type { Presence } from '../wire';
import { presenceColor } from './store';

/**
 * Coloured status dot for a player's presence. Inline SVG (no sprite
 * overhead); consumers compose with channel-list member rows, DM
 * partners, inspection panel headers, etc.
 */
export function PresenceDot({
  presence,
  size = 10,
  ring = '#2b2d31',
}: {
  presence: Presence;
  size?: number;
  ring?: string;
}): JSX.Element {
  return (
    <span
      role="img"
      aria-label={`presence: ${presence}`}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        background: presenceColor(presence),
        boxShadow: `0 0 0 2px ${ring}`,
        flexShrink: 0,
      }}
    />
  );
}
